import React, { useState, useEffect } from 'react';
import Confetti from 'react-confetti';

const ResultPage = ({ results, onRestartQuiz }) => {
  // États pour les animations
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [showConfetti, setShowConfetti] = useState(true);
  const [animateIn, setAnimateIn] = useState(false);

  // Effet pour gérer la taille de la fenêtre (pour les confettis)
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Effet pour déclencher l'animation d'entrée et arrêter les confettis après un certain temps
  useEffect(() => {
    // Déclencher l'animation d'entrée après un court délai
    const animationTimer = setTimeout(() => {
      setAnimateIn(true);
    }, 100);

    // Arrêter les confettis après 15 secondes
    const confettiTimer = setTimeout(() => {
      setShowConfetti(false);
    }, 15000);

    return () => {
      clearTimeout(animationTimer);
      clearTimeout(confettiTimer);
    };
  }, []);

  // Définitions des profils
  const profiles = {
    'La Maman Free': {
      description: 'Tu es une maman libre, spontanée, qui laisse ses enfants grandir à leur rythme, en toute confiance.',
      image: '/images/mama-free.png'
    },
    'La Maman Protectrice': {
      description: 'Tu es attentive, prudente, toujours prête à protéger et sécuriser ta famille.',
      image: '/images/mama-protectrice.png'
    },
    'La Maman Aimante': {
      description: 'Tu incarnes la douceur et l\'amour inconditionnel, offrant un cocon chaleureux à tes enfants.',
      image: '/images/mama-aimante.png'
    },
    'La Maman Battante': {
      description: 'Déterminée et ambitieuse, tu encourages tes enfants à se dépasser et à réussir.',
      image: '/images/mama-battante.png'
    }
  };

  const profile = profiles[results.mamaType];

  return (
    <div className="container">
      {/* Composant de confettis */}
      {showConfetti && (
        <Confetti
          width={windowSize.width}
          height={windowSize.height}
          numberOfPieces={200}
          recycle={false}
          colors={['#FF7900', '#F16E00', '#FFB800', '#FFC799', '#FFE0CC']}
        />
      )}
      
      <div className={`header ${animateIn ? 'animate-in' : ''}`}>
        <h1>Ton résultat</h1>
      </div>
      <div className={`result-container ${animateIn ? 'animate-in' : ''}`}>
        <h2 className="result-title">{results.mamaType}</h2>
        <p className="result-description">{profile.description}</p>
        <p className="result-score">Score total : {results.totalScore} points</p>
        
        {/* Image placeholder - à remplacer par des images réelles */}
        <div className="result-image-container">
          <img 
            src={profile.image} 
            alt={results.mamaType} 
            className="result-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/images/placeholder.png'; // Image de fallback
            }}
          />
        </div>
        
        {/* Logo Orange Money */}
        <div className="logo-container">
          <img 
            src="/images/bg/om-logo.png" 
            alt="Orange Money" 
            className="logo"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/images/logo-placeholder.png'; // Logo de fallback
            }}
          />
        </div>
      </div>
      <div className="share-container">
        <p>Prends une capture d'écran pour partager ton résultat !</p>
      </div>
      <button className="btn" onClick={onRestartQuiz}>Refaire le test</button>
    </div>
  );
};

export default ResultPage;
